import type { ReactNode } from "react";
import { Button, Card } from "react-bootstrap";
import { AbstractStep, type AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";

interface KoPageProps extends AbstractStepProps {
	koMessage: ReactNode;
	redirectionUrl: string;
}

export class KoPage extends AbstractStep<{}, KoPageProps> {
	protected renderContent(): ReactNode {
		const { koMessage, redirectionUrl } = this.props;

		return (
			<>
				<Card.Body className="text-center bg-success-700 text-white">
					<p className="font-weight-bold text-gold">
						A megadott adatok alapján sajnos nem vagy a jogosult az Otthon Start hitelre.
					</p>
					<p className="font-weight-bold">{koMessage}</p>
				</Card.Body>
				<Card.Footer className="bg-success">
					<p className="d-block text-white font-weight-bold">
						Nézd meg a Bankmonitor kalkulátorával, hogy milyen piaci kölcsönök érhetők el számodra.
					</p>
					<Button
						variant="gold"
						block
						href={redirectionUrl}
						onClick={() => this.sendEvent("BM_openCalculator")}
					>
						Kalkulátor megnyitása
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "KoPage";
	}
}
